// @flow
import * as React from "react";
import type { BrowserHistory } from "history";
import Button from "../Button";
import PageHeader from "../PageHeader";
import styles from "./ErrorPage.scss";
import statusErrors from "../../data/statusErrors";

export type ErrorPageProps = {
  pathname: string,
  push: $PropertyType<BrowserHistory, "push">,
  route403: string,
  route404: string,
  route500: string,
  redirectPath: string,
  isPortal: false,
  goBack: () => void
};

const configs = (route403, route404, route500) => ({
  [route403]: {
    status: 403,
    subheader: statusErrors(403)
  },
  [route404]: {
    status: 404,
    subheader: statusErrors(404)
  },
  [route500]: {
    status: 500,
    subheader: statusErrors(500)
  }
});

const ErrorPage = ({
  pathname,
  push,
  route403,
  route404,
  route500,
  redirectPath,
  goBack,
  isPortal = false
}: ErrorPageProps) => {
  const config = configs(route403, route404, route500)[pathname];
  const header = `Fehler${config ? ` ${config.status}` : ""}`;
  const subheader = config ? config.subheader : statusErrors(null);

  return (
    <>
      <div className={styles.pageHeaderContainer}>
        <PageHeader header={header} subheader={subheader} isCentered />
      </div>
      <div className={styles.buttonContainer}>
        <Button size="small" onClick={() => (isPortal ? goBack() : push(redirectPath))}>
          {isPortal ? "Zurück zum letzten Schritt" : "Anfrage fortsetzen"}
        </Button>
      </div>
    </>
  );
};

export default ErrorPage;
